import {TError} from '@app/types';
import showNotification from '@app/utils/showNotification';
import {Form} from 'antd';
import {t} from 'i18next';
import {useEffect} from 'react';
import {LogEvents, useSendEvent} from '@app/utils/logger';
import {
  useGetInventoryQuery,
  useUpsertInventoryMutation,
} from '@app/redux/services/inventoryService';

export interface IUseMemoForm {
  date: string;
  onCancel: () => void;
}

export const useMemoForm = ({date, onCancel}: IUseMemoForm) => {
  const [form] = Form.useForm<{memo: string}>();
  const sendEvent = useSendEvent();

  const [upsertInventory, {isLoading: isUpdating}] =
    useUpsertInventoryMutation();
  const {data, isLoading: isFetching} = useGetInventoryQuery({
    date,
  });

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      memo: data.memo,
    });
  }, [data, form]);

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      const result = await upsertInventory({
        date,
        body: values,
      }).unwrap();

      // Success feedback
      const successMessage = result?.id
        ? t('Successfully updated!')
        : t('Successfully registered!');
      showNotification(t('Success'), successMessage, 'bottomRight', 'success');
      onCancel();
    } catch (error) {
      const {data: errorData} = error as TError;

      // Send error event
      sendEvent(LogEvents.ERROR_PHARMACY_REGISTER, errorData);
    }
  };

  return {
    form,
    isLoading: isUpdating || isFetching,
    onSubmit,
  };
};
